export const basciUrl = 'https://api1.apitask.cc'